import React, { useState, useMemo } from 'react'
import { TabbedPage, Tab } from 'components/Shared/TabbedPage'
import MaterialGrid from 'components/Materials/MaterialGrid'
import ImportMaterials from 'components/Materials/ImportMaterials'
import AddMaterials from 'components/Materials/AddMaterials'
import FloatingActionButton from 'components/Shared/FloatingActionButton'
import AddIcon from '@material-ui/icons/Add';
import AuthCheck from 'components/Shared/AuthCheck'
import { useAppContext } from 'hooks/useAppContext'

const Materials = () => {
  const [activeTab, setActiveTab] = useState("MaterialGrid")
  const { selectedProjectData } = useAppContext()

  const tabs = useMemo(() => {
    const baseTabs = [
      new Tab({label: "Materials", value: "MaterialGrid", scope: "Materials", action: "read"}),
      new Tab({label: "Add Material", value: "AddMaterials", scope: "Materials", action: "update"})
    ]

    // Only show Import tab for projects with "Carolina" in the name
    const projectName = selectedProjectData?.ProjectName || ''
    if (projectName.toLowerCase().includes('carolina')) {
      baseTabs.push(new Tab({label: "Import", value: "ImportMaterials", scope: "Materials", action: "update"}))
    }

    return baseTabs
  }, [selectedProjectData])
  
  return (
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >
    {(() => {
        switch (activeTab) {
          case "MaterialGrid":   return <MaterialGrid />
          case "ImportMaterials":   return <ImportMaterials callback={() => { setActiveTab("MaterialGrid") }} />
          case "AddMaterials":   return <AddMaterials CRUDType="INSERT" callback={() => { setActiveTab("MaterialGrid") }}/>
          default:      return <MaterialGrid />
        }
      })()}   
    <AuthCheck scope="Materials" action="create"><FloatingActionButton onClick={() => { setActiveTab("AddMaterials") }}><AddIcon /></FloatingActionButton></AuthCheck>
    </TabbedPage>
  )
}

export default Materials